import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { UserUrl } from '../../shared/urls/user.url';

@Injectable()
export class SelectCentreService {
  constructor(public baseService: BaseService) {}
  getUserCentre() {
    const url = UserUrl.GET_USER_CENTRES;
    return this.baseService.getData(url);
  }

  getUserPermission(centreId) {
    const url = UserUrl.GET_USER_PERMISSION;
    return this.baseService.getData(url + `/${centreId}`);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/select-centre/select-centre.service.ts